// src/app/services/loading.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface LoadingState {
  isLoading: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<LoadingState>({
    isLoading: false,
  });

  public loading$: Observable<LoadingState> =
    this.loadingSubject.asObservable();

  /**
   * Show loading spinner with optional message
   */
  show(message?: string): void {
    this.loadingSubject.next({ isLoading: true, message });
  }

  /**
   * Hide loading spinner
   */
  hide(): void {
    this.loadingSubject.next({ isLoading: false });
  }

  /**
   * Get current loading state
   */
  isLoading(): boolean {
    return this.loadingSubject.value.isLoading;
  }
}
